import { useQuery } from '@tanstack/react-query';

import { CronJobConfig, CronJobsService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useFetchCronJobConfigs = () => {
  return useQuery<CronJobConfig[]>([QueryKeys.fetchCronJobConfigs], async () => {
    return await CronJobsService.cronJobsControllerFetchCronJobConfigs();
  });
};
